<div class="p-3 bg" style="margin-top: 100px;">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1 style="color: #e04787;">Configuration Required</h1>
            <ul>
                <li>
                    <a [routerLink]="['/freemock']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="el-blog-single-wrapper el-blog-medium-wrapper pt-4">
    <div class="container">

        <div class="el-inner-blog-box el-blog-single-form">
            <h4 class="el-blog-title">Instruction </h4>
            <div class="row">
                <div class="col-md-12">
                    <p><strong> This page will check the configuration required for the
                            examination and may take a few seconds to complete.</strong></p>
                </div>
                <div class="col-md-12" style="margin-top:10px;">
                    <div class="row">
                        <div style="width:40%;float:left">
                            <i class="fa fa-camera fa-6" style="font-size:35px;color:#42a5f5"></i>
                            <p>Camera</p>
                        </div>
                        <div style="width:60%;float:left">
                            <i class="fa fa-check-circle fa-2x" style="color:#5cb85c;" *ngIf="Object.Camera"></i>
                            <i class="fa fa-times-circle fa-2x" style="color:red" *ngIf="Object.Camera!=true"></i>
                        </div>
                    </div>
                    <div class="row">
                        <hr />
                    </div>
                    <div class="row">
                        <div style="width:40%;float:left">
                            <i class="fa fa-microphone fa-6" style="font-size:35px;color:#42a5f5"></i>
                            <p>Microphone</p>
                        </div>
                        <div style="width:60%;float:left">
                            <i class="fa fa-check-circle fa-2x" style="color:#5cb85c;" *ngIf="Object.Microphone"></i>
                            <i class="fa fa-times-circle fa-2x" style="color:red" *ngIf="Object.Microphone!=true"></i>
                        </div>
                    </div>
                    <div class="row">
                        <hr />
                    </div>
                    <div class="row">
                        <div style="width:40%;float:left">
                            <i class="fa fa-globe fa-6" style="font-size:35px;color:#42a5f5"></i>
                            <p> Browser: {{Object.BrowserName}}({{Object.Version}})</p>
                        </div>
                        <div style="width:60%;float:left">
                            <i class="fa fa-check-circle fa-2x" style="color:#5cb85c;" *ngIf="Object.enableBrowser"></i>
                            <i class="fa fa-times-circle fa-2x" style="color:red"
                                *ngIf="Object.enableBrowser!=true"></i>

                            <a target="_blank" *ngIf="Object.IsVersionIssue && Object.IsMobile==false"
                                style="cursor:pointer;color:red;"
                                href="https://www.google.com/chrome/?brand=CHBD&gclid=EAIaIQobChMI1Yf48MPF7AIV-IJLBR10sgj8EAAYASAAEgJA5fD_BwE&gclsrc=aw.ds">Downlod
                                Chrome</a>
                            <a target="_blank" *ngIf="Object.IsVersionIssue && Object.IsMobile==true"
                                style="cursor:pointer;color:red;"
                                href="https://play.google.com/store/apps/details?id=com.android.chrome">Downlod
                                Chrome</a>

                        </div>
                    </div>

                    <div class="row">
                        <hr />
                    </div>
                    <div class="row">
                        <div style="width:40%;float:left">
                            <i class="fa fa-flag-checkered fa-6" style="font-size:35px;color:#42a5f5"></i>
                            <p>Internet Speed <br /><strong>{{Object.NetSpeed}} mbps</strong></p>
                        </div>
                        <div style="width:60%;float:left">
                            <i class="fa fa-check-circle fa-2x" style="color:#5cb85c;"></i>
                        </div>

                    </div>

                </div>


                <br />
                <div class="row"
                    *ngIf="Object.Camera==false || Object.Microphone==false || Object.enableBrowser==false">
                    <div class="col-md-12">
                        <i class="fa fa-exclamation-triangle" style="font-size:20px; color:red;">
                        </i> Your device does not meet the required configuration. Please write to
                        us at <i><strong>info&#64;silverzone.org</strong></i>.
                    </div>
                </div>

                <div class="row" style="margin-top:10px;">
                    <div class="col-md-12">
                        <p style="color:#5cb85c;margin-top:10px;"
                            *ngIf="Object.Camera==true && Object.Microphone==true && Object.enableBrowser==true">
                            <i class="fa fa-thumbs-up" style="font-size:20px;"></i>&nbsp;&nbsp;
                            <strong>Configuration check complete. Your device meets all the required
                                configuration for the examination.</strong>
                        </p>
                        <span>


                            <button (click)="Proceed()" style="margin-top: 20px;"
                                *ngIf="Object.Camera && Object.Microphone && Object.enableBrowser" class="el-btn py-4">
                                Proceed
                            </button>

                        </span>
                    </div>
                </div>


            </div>



        </div>
    </div>
</div>